// TODO STUDIO MIGRATION (Phase 6): middleware /mindmap/generate now returns { jobId, room }. Migrate to enqueueMindmapGenerate() + useJobSocket(jobId, onEvent) from common/server_utils.es6 and _editor/utils/jobSocket.js respectively.
import React, { useState } from "react";
import PropTypes from "prop-types";
import { LuMusic4, LuX } from "react-icons/lu";
import i18n from "i18next";

const AudioPanel = ({ onAudioOptionSelected, selectedOption, onClose }) => {
  const [internalSelectedOption, setInternalSelectedOption] = useState(
    selectedOption || "scene-sounds"
  );

  const audioOptions = [
    {
      id: "scene-sounds",
      label: i18n.t("AudioPanel.SceneSounds"),
    },
    {
      id: "document-summary",
      label: i18n.t("AudioPanel.DocumentSummary"),
    },
    {
      id: "outline",
      label: i18n.t("AudioPanel.DocumentTitles"),
    },
    {
      id: "mindmap",
      label: i18n.t("AudioPanel.Mindmap"),
    },
    {
      id: "narration-texts",
      label: i18n.t("AudioPanel.NarrationTexts"),
    },
  ];

  const effectiveSelectedOption = selectedOption || internalSelectedOption;

  const getOptionIcon = (isActive) => {
    const color = isActive ? "#7F56D9" : "#8F8F8F";
    return <LuMusic4 size={18} color={color} />;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "12px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: 600,
            color: "#0f172a",
            marginBottom: 4,
          }}
        >
          <span>{i18n.t("AudioPanel.Audio")}</span>
          <LuX style={{ cursor: "pointer", color: "#64748b" }} onClick={onClose} size={18} />
        </div>
        {audioOptions.map((option) => {
          const isActive = effectiveSelectedOption === option.id;
          return (
            <button
              key={option.id}
              type="button"
              onClick={() => {
                setInternalSelectedOption(option.id);
                if (onAudioOptionSelected) {
                  onAudioOptionSelected(option.id);
                }
              }}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "10px 16px",
                gap: "8px",
                width: "100%",
                height: 40,
                background: isActive ? "#E0D2FF" : "#FCFCFC",
                border: isActive ? "1px solid #A963F5" : "1px solid #EBEBEB",
                borderRadius: 8,
                color: "#475569",
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 20,
                  height: 20,
                }}
              >
                {getOptionIcon(isActive)}
              </span>
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

AudioPanel.propTypes = {
  onAudioOptionSelected: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
};

export default AudioPanel;
